export default `float de(vec3 p){
  float t = time;
  float s = 1.;
  p.z += t * .1;
  p+=.5;
  float c = length(mod(p, 1.)-.5)-.7;
  for(int i = 0; i < 12; i++) {
    p.xy*=rot(time * .01);
    p*=1.3;
    s*=1.3;
    c = max(c, -(length(mod(p, 1.)-.5)-.4)/s);
  }
  return c;
}`